var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.items,"item-text":_vm.formatName,"item-value":"name"}},'v-autocomplete',{
        label: 'Timezone',
        loading: _vm.loading,
        ..._vm.$attrs,
    },false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }